import { useDisclosure } from '@/hooks';
import { Image, Modal } from 'antd';

export default function IntegrationConceptBr() {
  const [open, action] = useDisclosure();

  return (
    <>
      <Image
        src="/images/logo-conceptbr.png"
        onClick={action.open}
        style={{ cursor: 'pointer' }}
        preview={false}
        height={50}
      />

      <Modal
        title={
          <Image src="/images/logo-conceptbr.png" preview={false} height={50} />
        }
        open={open}
        onCancel={action.close}
        okButtonProps={{ style: { display: 'none' } }}
        cancelText="Fechar"
      >
        <strong>
          Temos agora a integração com a ConceptBR em nosso módulo CRM, onde são
          especialistas em oficinas.
        </strong>

        <p>
          Se sua empresa possui vínculo com a ConceptBR, os dados são
          automaticamente enviados com seu consentimento, onde a ConceptBR entra
          em contato com nosso time da plataforma Ultracar para o envio e
          atualização diária.
        </p>

        <p>
          <strong>Como funciona?</strong>
          <br />
          <ul>
            <li>
              A integração é automática e transparente, feita diretamente entre
              o sistema da plataforma Ultracar e a ConceptBR.
            </li>
            <li>Nenhuma ação adicional é necessária por parte do usuário.</li>
            <li>
              Somente empresas que possuem contrato com a ConceptBR terão os
              dados sincronizados.
            </li>
          </ul>
        </p>

        <p>
          Quer saber mais ou deseja integrar sua empresa a ConceptBR?
          <a
            style={{ fontWeight: 500 }}
            href={process.env.REACT_APP_SUPPORT_URL}
            target="_blank"
          >
            Clique aqui e entre em contato com nosso time de suporte, para
            abertura de chamado para que possamos programar sua liberação.
          </a>
        </p>

        <p style={{ fontWeight: 600 }}>
          Fique ligado! em breve lançaremos novas integrações com outras
          soluções de CRM para tornar sua gestão ainda mais completa.
        </p>
      </Modal>
    </>
  );
}
